import { APIEndpoints,initAPIEndpoints } from "./APIEndpoints";

let endpoints = {};

Object.values(APIEndpoints).forEach(value => endpoints[value.name] = value);
initAPIEndpoints(true);
const appBaseUrl = `${location.protocol}//${location.host}`;
const CognitoConfig = (userPoolClientId) =>({
          identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
          region: process.env.REACT_APP_AWS_REGION,
          userPoolId:process.env.REACT_APP_AWS_USER_POOL_ID,
          userPoolClientId,
          signUpVerificationMethod: 'code'
        });
const LoginConfig = {
  loginWith: {
        oauth: {
          domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [appBaseUrl],
          redirectSignOut: [appBaseUrl],
          responseType: "code"
        }
      }
}        
export const awsConfig = (opts={})=>{
    let endpoints = {};
    Object.values(initAPIEndpoints(!!opts.userRelativePath)).forEach(value => endpoints[value.name] = value);
    return {
      Auth: {
        Cognito:{
          ...CognitoConfig(process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID),
          ...(opts.loginWithOAuth?LoginConfig:{})
        }
      },

      API: {
        REST:{
          ...endpoints
        }
      },
    };
}
